    // MaterialReservationApp.js
import React from "react";
import { Container } from "@mui/material";
import { useMaterialReservation } from './MaterialReservationContext';
import { MaterialenOverzicht } from './MaterialenOverzicht';
import { DraaidagenOverzicht } from './DraaidagenOverzicht';

export const AppContent = React.memo(function AppContent() {
    const { selectedDraaidag } = useMaterialReservation();

    return (
        <Container maxWidth="lg" style={{ marginTop: '0px' }}>
            {selectedDraaidag ? 
                <MaterialenOverzicht /> 
            : 
                <DraaidagenOverzicht />
            }
        </Container>
    );
});
    